import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { SupervisorResponse } from '@/main/models/response/supervisorResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveSupervisors, saveSupervisorsDomain } from './supervisorActions';
import { GetSupervisors, GetSupervisorsDomain } from './supervisorTypes';

// Api's
import { supervisorApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getSupervisorsSaga({ payload }: GetSupervisors) {
  try {
    const response: AxiosResponse<SupervisorResponse> = yield call(
      supervisorApi.getSupervisor,
      payload.request
    );

    if (response.data) {
      yield put(
        saveSupervisors(
          response.data,
          false,
          null,
          payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveSupervisors(
          null,
          true,
          resultError.messagesDataError,
          payload.keyReducer
        )
      );
    }
  }
}

export function* getSupervisorsDomainSaga(action: GetSupervisorsDomain) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      supervisorApi.getDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(
        saveSupervisorsDomain(
          response.data.result,
          false,
          null
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveSupervisorsDomain(
          null,
          true,
          resultError.messagesDataError
        )
      );
    }
  }
}